// extracted by mini-css-extract-plugin
export var container = "RegisterInvitedUser-module--container--8ZPd7";
export var error = "RegisterInvitedUser-module--error--NNmr+";
export var formContainer = "RegisterInvitedUser-module--formContainer--MRmC5";
export var welcomeContent = "RegisterInvitedUser-module--welcomeContent--YO7W4";